import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import { baseApi } from '../config';
import {
  requestErrorInterceptor,
  requestInterceptor,
} from './interceptors/requestInterceptor';
import {
  responseErrorInterceptor,
  responseInterceptor,
} from './interceptors/responseInterceptor';

interface IRequest {
  get: (url: string, path?: string) => Promise<AxiosResponse<unknown>>;
  delete: (url: string, path?: string) => Promise<AxiosResponse<unknown>>;
  post: (
    url: string,
    body: unknown,
    path?: string,
    config?: AxiosRequestConfig,
  ) => Promise<AxiosResponse<unknown>>;
  put: (
    url: string,
    body: unknown,
    path?: string,
  ) => Promise<AxiosResponse<unknown>>;
}

export default class Api {
  static getInstance(): { request: IRequest } {
    const originalAxios = axios.create({
      baseURL: baseApi,
      withCredentials: true,
      timeout: 10000, // Adjust as necessary
    });

    originalAxios.interceptors.request.use(
      requestInterceptor,
      requestErrorInterceptor,
    );
    originalAxios.interceptors.response.use(
      responseInterceptor,
      responseErrorInterceptor,
    );

    const request: IRequest = {
      get: async (url: string) => {
        return await originalAxios.get(url).catch((error) => {
          console.error(error);
          throw error;
        });
      },
      delete: async (url: string) => {
        return originalAxios.delete(url).catch((error) => {
          console.error(error);
          throw error;
        });
      },
      post: async (
        url: string,
        data: unknown,
        path?: string,
        config?: AxiosRequestConfig,
      ) => {
        return originalAxios.post(url, data, config).catch((error) => {
          console.error(error);
          throw error;
        });
      },
      put: async (url: string, data: unknown) => {
        return originalAxios.put(url, data).catch((error) => {
          console.error(error);
          throw error;
        });
      },
    };

    return {
      request,
    };
  }
}
